export const LAUNCH_SIDEBAR = 'LAUNCH_SIDEBAR';
